'use strict';

// Go landing pages

angular.module('landing', ['templates', 'msCore']).config(['$stateProvider', function ($stateProvider) {
  $stateProvider.state('landing', {
    url: '/:org/:sub?ref',
    templateUrl: 'landing/pages/landing.html',
    controller: 'LandingCtrl',
    controllerAs: 'vm',
    data: {
      noAuth: true
    },
    // this is required for IE8 to work!
    params: {
      org: {
        value: null,
        squash: true
      },
      sub: {
        value: null,
        squash: true
      },
      ref: {
        value: null
      }
    }
  });
}]).run(['eventTrackingSvc', function (eventTrackingSvc) {
  eventTrackingSvc.init();
  // send pageviews to google analytics
  eventTrackingSvc.registerEventListeners();
}]);

// Student landing pages
// - similar to Go landing pages but powered by separate controller, styles, and markup
angular.module('studentLanding', ['templates', 'msCore']).config(['$stateProvider', function ($stateProvider) {
  $stateProvider.state('student', {
    url: '/:org/:sub?ref',
    templateUrl: 'landing/pages/student-landing.html',
    controller: 'StudentLandingCtrl',
    controllerAs: 'vm',
    data: {
      noAuth: true
    },
    // this is required for IE8 to work!
    params: {
      org: {
        value: null,
        squash: true
      },
      sub: {
        value: null,
        squash: true
      },
      ref: {
        value: null
      }
    }
  });
}]).run(['eventTrackingSvc', function (eventTrackingSvc) {
  eventTrackingSvc.init();
  // send pageviews to google analytics
  eventTrackingSvc.registerEventListeners();
}]);